import { render } from "./ProjectSubmitterPage.vue?vue&type=template&id=f473cb76&scoped=true"
import script from "./ProjectSubmitter.js?vue&type=script&lang=js&external"
export * from "./ProjectSubmitter.js?vue&type=script&lang=js&external"

import "./ProjectSubmitterPage.vue?vue&type=style&index=0&id=f473cb76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f473cb76"]])

export default __exports__